import React, { useState } from 'react';
import { Breadcrumbs, Card, Grid, Header1Text, NavigationItem, SpaceWrapper, TextInput } from 'ui-toolkit/components';
import { ILenderCompanyData } from '../../types/lenders/ILenderCompany';
import { LenderCompaniesTable } from '../../components/lenders/LenderCompaniesTable';
import { ClientUrlFactory } from '../../ui-toolkit/rest/ClientUrlFactory';
import { useListLendersQuery } from '../../API/lenders/LenderCompanyApi';
import { ErrorMessageTW } from '../../tailwindComponents/errorMessage/ErrorMessageTW';

export const LenderCompaniesPage: React.FC = () => {
  const {
    data: allLenders = [],
    isLoading: isLenderCompanyLoading,
    error: fetchError,
  } = useListLendersQuery({ includeDeactivated: true });
  const [filter, setFilter] = useState<string | null>(null);

  const filteredLenders = allLenders.filter((lender: ILenderCompanyData) =>
    !!filter ? lender.name.toLowerCase().includes(filter.toLowerCase()) : true
  );

  return (
    <SpaceWrapper topSpace={'none'}>
      <Grid>
        <ErrorMessageTW rtkError={fetchError} />
        <Breadcrumbs
          homeLink={ClientUrlFactory().urlFor.adminOrders()}
          links={[
            {
              to: ClientUrlFactory().urlFor.lendersIndex(),
              text: 'Lenders',
            },
          ]}
        />
        <Header1Text>Lender Companies</Header1Text>
        <Grid columnCount={2}>
          <TextInput value={filter} placeholder={'Search'} onChange={setFilter} />
        </Grid>
        <Card>
          <NavigationItem
            text={'Add Lender Company'}
            to={ClientUrlFactory().urlFor.lenderCompanyCreate()}
            isActive
            isPrimary
          />
          <LenderCompaniesTable data={filteredLenders} isLoading={isLenderCompanyLoading} />
        </Card>
      </Grid>
    </SpaceWrapper>
  );
};
